<template>
  <div class="data-state">
    <div class="form-container">
      <el-select
        @change="getState"
        class="white"
        v-model="warehouseId"
        placeholder="请选择仓库"
      >
        <el-option
          v-for="item in warehouse"
          :key="item.id"
          :label="item.name"
          :value="item.id"
        ></el-option>
      </el-select>
      
      <el-button class="btn-white" @click="toBigScreen">看板投屏</el-button>
    </div>
    <div class="table-container">
      <div class="table">
        <el-table :data="baseInfoData" style="width: 85%">
          <el-table-column prop="dateTime" label="日期"></el-table-column>
          <el-table-column prop="rentIncome" label="场租导入"></el-table-column>
          <el-table-column prop="orders" label="订单导入"></el-table-column>
          <el-table-column
            prop="orderExpressStatistics"
            label="快递费统计"
          ></el-table-column>
          <el-table-column
            prop="orderExpressCount"
            label="快递费计算"
          ></el-table-column>
          <el-table-column
            prop="operateIncome"
            label="操作收入"
          ></el-table-column>
          <el-table-column
            prop="operateCost"
            label="人员支出"
          ></el-table-column>
          <el-table-column label="操作">
            <template slot-scope="scope">
              <el-button
                v-if="scope.row.status === 0"
                type="text"
                class="btn-text"
                @click="publish(scope.row.dateTime)"
                >发布</el-button
              >
              <span v-else>已发布</span>
            </template>
          </el-table-column>
        </el-table>
      </div>
      <div class="table">
        <el-table :data="otherFeeData" style="width: 85%">
          <el-table-column prop="dateTime" label="日期"></el-table-column>
          <el-table-column
            prop="otherFee"
            label="其他费用导入状况"
          ></el-table-column>
        </el-table>
      </div>
    </div>
  </div>
</template>

<script>
import Expenses from "models/expenses";
const expenses = new Expenses();
import DataState from "models/data-state";
const dataState = new DataState();
export default {
  data() {
    return {
      warehouseId: "",
      warehouse: [],
      baseInfoData: [
        // {
        //   dateTime: "",
        //   rentIncome: "",
        //   orders: "",
        //   operateCost: ""
        // }
      ],
      otherFeeData: []
    };
  },
  created() {
    this.getWarehouse();
  },
  methods: {
    toBigScreen() {
      window.open("/big-screen", "_blank");
      // this.$router.push("/big-screen");
    },
    //获取仓库数据
    getWarehouse() {
      expenses.getWarehouseData().then(res => {
        if (res.success) {
          let arr = [];
          res.result.map(value => {
            let obj = {};
            obj.id = value.id;
            obj.name = value.name;
            arr.push(obj);
          });
          this.warehouse = arr;
          this.warehouseId = arr[0].id;
          this.getState();
        }
      });
    },
    getState() {
      let warehouseId = this.warehouseId;
      if (warehouseId) {
        dataState.getDataState(warehouseId).then(res => {
          if (res.success) {
            let baseInfoData = [];
            let otherFeeData = [];
            res.result.baseInfoList.map(value => {
              let obj = {};
              obj.dateTime = value.dateTime;
              obj.rentIncome = value.rentIncome === 1 ? "√" : "×";
              obj.orders = value.orders === 1 ? "√" : "×";
              obj.operateCost = value.operateCost === 1 ? "√" : "×";
              obj.operateIncome = value.operateIncome === 1 ? "√" : "×";
              obj.orderExpressStatistics =
                value.orderExpressStatistics === 1 ? "√" : "×";
              obj.orderExpressCount = value.orderExpressCount === 1 ? "√" : "×";
              obj.status = value.status;
              baseInfoData.push(obj);
            });
            res.result.otherFeeList.map(value => {
              let obj = {};
              obj.dateTime = value.dateTime;
              obj.otherFee = value.otherFee === 1 ? "√" : "×";
              obj.status = value.status;
              otherFeeData.push(obj);
            });
            this.baseInfoData = baseInfoData;
            this.otherFeeData = otherFeeData;
          }
        });
      } else {
        this.$message.error("请选择仓库");
      }
    },
    publish(time) {
      this.$confirm("是否确定发布?", "发布", {
        confirmButtonText: "确定",
        cancelButtonText: "取消",
        type: "warning"
      })
        .then(() => {
          let warehouseId = this.warehouseId;
          let dateTime = time;
          dataState.getDataPublish(warehouseId, dateTime).then(res => {
            if (res.success) {
              this.getState();
              this.$message.success("发布成功");
            } else {
              this.$message.error(res.message);
            }
          });
        })
        .catch(() => {});
    }
  }
};
</script>
<style lang="scss" scoped>
.data-state {
  flex: 1;
  display: flex;
  flex-direction: column;
  .form-container {
    padding: 16px;
    background: #fff;
    border-radius: 4px;
    margin-bottom: 16px;
    display: flex;
    justify-content: space-between;
    align-items: center;
    .el-button {
      margin-left: 16px;
    }
  }
  .table-container {
    min-height: 500px;
    padding: 16px;
    background: #fff;
    border-radius: 4px;
    .table {
      margin-bottom: 20px;
    }
  }
}
</style>
